import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tw-w-full" }
const _hoisted_2 = {
  key: 0,
  class: "tw-block tw-mb-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500"
}
const _hoisted_3 = {
  key: 1,
  class: "tw-w-full tw-flex tw-items-stretch"
}
const _hoisted_4 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-l-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-3 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5"
}
const _hoisted_5 = ["value", "placeholder"]
const _hoisted_6 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-r-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-3 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5"
}
const _hoisted_7 = {
  key: 2,
  class: "tw-min-h-[40px] tw-flex tw-items-center tw-text-sm tw-text-slate-800"
}
const _hoisted_8 = { class: "tw-truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_ctx.isEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.prefix)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.prefix), 1))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            value: _ctx.modelValue ?? _ctx.value,
            placeholder: _ctx.placeholder,
            type: "text",
            class: _normalizeClass(["tw-w-full tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm tw-shadow-slate-900/5 tw-transition placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55", [
          _ctx.prefix && _ctx.suffix ? 'tw-border-l-0 tw-border-r-0' : '',
          _ctx.prefix && !_ctx.suffix ? 'tw-rounded-r-xl tw-border-l-0' : '',
          _ctx.suffix && !_ctx.prefix ? 'tw-rounded-l-xl tw-border-r-0' : '',
          !_ctx.prefix && !_ctx.suffix ? 'tw-rounded-xl' : '',
        ]]),
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateInput && _ctx.updateInput(...args)))
          }, null, 42, _hoisted_5),
          (_ctx.suffix)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.suffix), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.modelValue ?? _ctx.value), 1)
        ]))
  ]))
}